/*
 * Tier 11 implementation for modal lightbox on product images
 * */
document.addEventListener("DOMContentLoaded", function () {
  var mySwiper = new Swiper(".swiper-container", {
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
    },
  });

  const closeBtn = document.querySelector("#myModal .close");
  closeBtn.addEventListener("click", closeModal);

  const images = document.querySelectorAll(".openModal-image");
  images.forEach((image) => {
    image.addEventListener("click", function () {
      openModal(image.dataset.indexSlide);
    });
  });

  function openModal(indexSlide) {
    var modal = document.getElementById("myModal");
    modal.style.display = "block";

    mySwiper.slideTo(indexSlide);

    window.onclick = function (event) {
      if (event.target == modal) {
        modal.style.display = "none";
      }
    };
  }

  function closeModal() {
    var modal = document.getElementById("myModal");
    if (modal) {
      modal.style.display = "none";
    } else {
      console.error("Modal not found 2");
    }
  }
});
